import { ComponentRegistration } from '@netc/intersection-hydrator';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations: ComponentRegistration[] = [
  {
    name: 'Header',
    import: (): Promise<any> => import('@stories/Widgets/Global/Header/Header'),
    config: {
      hydrate: 'always',
    },
  },
  {
    name: 'Footer',
    import: (): Promise<any> => import('@stories/Widgets/Global/Footer/Footer'),
    config: {
      hydrate: 'never',
    },
  },
  {
    name: 'Timeline',
    import: (): Promise<any> => import('@stories/Widgets/Timeline/Timeline'),
    config: {
      hydrate: 'in-view',
    },
  },
];
